var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD"},[_c('aha-breadcrumb'),_vm._v(" "),_c('science-news-heading'),_vm._v(" "),_c('section-heading'),_vm._v(" "),_c('rich-text'),_vm._v(" "),_c('news-link'),_vm._v(" "),_c('phd-citations')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f2360ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/components/things-to-know.vue
// module id = 1358
// module chunks = 0